import { useEffect, useState } from 'react'
import { autorun } from 'mobx'
import { get } from 'lodash'

import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import { MenuList } from 'Components/Elements/UserAccountMenu/CardMenu'
import storeUser from 'GlobalStores/User/StoreUser'

const DEFAULT_USER_PATH = '/user'

const useUserMenuPath = () => {
    const [userPath, setUserPath] = useState(DEFAULT_USER_PATH)

    useEffect(() => {
        const disposer = autorun(() => {
            const baStatus = storeUser.GetBaStatus()
            if (!baStatus) return

            const jpMenuList = [MenuList[0], MenuList[2], MenuList[1], MenuList[3]]
            const defaultMenuList = StoreCountry.Country3() === 'JPN' ? jpMenuList : MenuList

            const filteredMenuList = defaultMenuList.filter(item => {
                const isInvite = item.key === 'invite'
                if (baStatus !== 'H') return true
                return !isInvite
            })

            setUserPath(get(filteredMenuList, '[0].key', DEFAULT_USER_PATH))
        })

        return () => {
            disposer()
        }
    }, [])

    return userPath
}

export default useUserMenuPath

